import { Pipe, PipeTransform } from '@angular/core';
import { MaritalStatusName } from '@app-models/marital-status.model';

const maritalStatusMap = new Map<number, MaritalStatusName>();
maritalStatusMap
  .set(1, 'divorced')
  .set(2, 'free union')
  .set(3, 'married')
  .set(4, 'single')
  .set(5, 'widower');

@Pipe({
  name: 'maritalStatus',
})
export class MaritalStatusPipe implements PipeTransform {
  transform(maritalStatusId: number): string {
    return maritalStatusMap.get(maritalStatusId);
  }
}
